export enum UploadState {
  Idle = "IDLE",
  Starting = "STARTING",
  InProgress = "IN_PROGRESS",
  Succeeded = "SUCCEEDED",
  Failed = "FAILED",
  Cancelled = "CANCELLED",
}
